module.exports = __webpack_public_path__ + "static/media/tennis.77f2f3aa.png";